import { Box, Icon, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { RouteProp, useNavigation, useRoute } from '@react-navigation/core'
import { StackNavigationProp } from '@react-navigation/stack'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Platform, ScrollView, StyleSheet, TouchableOpacity } from 'react-native'
import { LoaderNew } from '../../../../../libs/ui-new/src/comps/LoaderNew'
import { AepsButton } from '../../comps/AepsButton'
import { RowItem } from '../../comps/RowItem'
import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { BbpsStackParamList, LRNMappingItem } from '../../nav/Bbps'
import { Screens } from '../../nav/Screens'
import { generateRandomString, getErrorMessage } from '../../util/utill'
import { BillerCard } from './BillerCard'
import { Container } from './Container'
import { CustomTab } from './CustomTab'
import { ErrorState, NoPlansState, PlanSkeletonList } from './PlanSkeleton'

type ApiHandlerResult = {
  data: any
  state: 'pending' | 'fulfilled' | 'rejected' | undefined
}

type MobileBillPaymentRouteProp = RouteProp<BbpsStackParamList, typeof Screens.MOBILE_BILL_PAYMENTS>
type BbpsNavigationProp = StackNavigationProp<BbpsStackParamList>

type MobileBillPaymentRouteParams = {
  mobileNumber: string
  categoryId: number | string
  displayName: string
  categoryName: string
  lrnMapping: LRNMappingItem[]
}
interface RechargePlan {
  id: string
  packageName: string
  amount: string
  talktime: string
  validity: string
  data: string
  description: string
  category: string
  subcategory: string
  topPlan: 'Y' | 'N'
}
interface PlanWrapper {
  rechargePlan: RechargePlan
}
interface PlansByTab {
  [tabName: string]: PlanWrapper[]
}
interface TabMeasurement {
  x: number
  width: number
}
interface Operator {
  id: number
  name: string
  logoName?: string
}
interface Circle {
  circleMasterId: number
  circleName: string
}

export const MobileBillPayment = () => {
  const CATEGORY_ID_MOBILE_PREPAID = 100001
  console.log('MobileBillPayment Component Render Start (Prepaid Flow)')
  type PaymentProcessingNavigationProp = StackNavigationProp<BbpsStackParamList>
  const navigation = useNavigation<PaymentProcessingNavigationProp>()
  const route = useRoute<MobileBillPaymentRouteProp>()
  const [showPaymentProcessModal, setShowPaymentProcessModal] = useState(false)
  const jiopayWindowRef = useRef<Window | null>(null)
  const [plansByTab, setPlansByTab] = useState<PlansByTab>({})
  const [activeTab, setActiveTab] = useState('payBills')
  const [showInactivityDialog, setShowInactivityDialog] = useState(false)
  const [showAllTabsDialog, setShowAllTabsDialog] = useState(false)
  const [showOperatorList, setShowOperatorList] = useState(false)
  const [showCircleList, setShowCircleList] = useState(false)
  const [operatorList, setOperatorList] = useState<Operator[]>([])
  const [loadingOperators, setLoadingOperators] = useState(false)
  const [operatorError, setOperatorError] = useState<string | null>(null)
  const [circleList, setCircleList] = useState<Circle[]>([])
  const [circleListError, setCircleListError] = useState<string | null>(null)

  const [editableAmount, setEditableAmount] = useState<string>('')

  const [showMappingErrorDialog, setShowMappingErrorDialog] = useState(false)
  const [loadingCircles, setLoadingCircles] = useState(false)
  const [selectedOperator, setSelectedOperator] = useState<Operator | null>(null)
  const [selectedCircle, setSelectedCircle] = useState<Circle | null>(null)
  const [billerType, setbillerType] = useState('')
  const [loadingPlans, setLoadingPlans] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [planError, setPlanError] = useState<string | null>(null)
  const [selectedPlanDetails, setSelectedPlanDetails] = useState<RechargePlan | null>(null)
  const [tabMeasurements, setTabMeasurements] = useState<Record<string, TabMeasurement>>({})
  const tabsRef = useRef<ScrollView>(null)
  const containerWidthRef = useRef<number>(0)
  const routeParams = route.params as MobileBillPaymentRouteParams
  const mobileNumber = routeParams.mobileNumber || '8369186718'
  const lrnMappingData = routeParams.lrnMapping || []
  const categoryId = routeParams?.categoryId || '100001'
  const operatorId = selectedOperator?.id
  const circleId = selectedCircle?.circleMasterId
  const operatorName = selectedOperator?.name
  const circleName = selectedCircle?.circleName
  const tabKeys = Object.keys(plansByTab)
  const activePlans = plansByTab[activeTab] || []

  const [planId, setplanId] = useState('')
  const [beneficiaryID, setbeneficiaryID] = useState('0')
  const [nickName, setnickName] = useState('NA')
  const [paymentAmount, setpaymentAmount] = useState('')
  const [agentFeeAmount, setagentFeeAmount] = useState('')
  const [productId, setproductId] = useState('')
  // const [circleID, setCircleID] = useState(circleId)
  // const [returnUrl, setreturnUrl] = useState(
  //   'https://psp-mandate-merchant-sit.jiomoney.com:3003/billpay/transaction-status',
  // )
  const [returnUrl, setreturnUrl] = useState('https://sit-atsweb.test.jiobank.in/pg-redirect/jpb/bbps/order-status')

  const { getProductListBC } = useStores((root) => ({
    getProductListBC: root.BillPaymentAgentOnboard.getProductListBC,
  }))

  const { setOrderId } = useStores((root) => ({
    setOrderId: root.BillPaymentAgentOnboard.setOrderId, // Map the action here
  }))

  const [lazycallGetProductListBC, callGetProductListBCHandler] = useLazyApiData(getProductListBC)

  // useEffect(() => {
  //   lazycallGetProductListBC()
  // }, [])

  // useEffect(() => {
  //   if (callGetProductListBCHandler.state === 'fulfilled') {
  //     const response = callGetProductListBCHandler.data
  //     setbillerType(response?.product?.type)

  //     console.log('RECHARGE: API callGetProductListBCHandler Done successfully! Response:', response)
  //   }
  // }, [])

  const jfsUserId = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  const merchantUserId = jfsUserId
  // const merchantUserId = RootStore.BillPaymentAgentOnboard.jfsUserId;
  const customerMobile = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A'
  const customerFirstName = RootStore.BillPaymentAgentOnboard.tempCustomerData?.firstName || ''
  const customerLastName = RootStore.BillPaymentAgentOnboard.tempCustomerData?.lastName || ''
  const customerFullName = `${customerFirstName} ${customerLastName}`.trim() || 'Customer Name'

  // const initialBillAmount = extractMetaValue(billObject, 'Bill Amount')
  // const minAmount = parseFloat(billObject?.product?.minAmount || '0.00')
  // const maxAmount = parseFloat(billObject?.product?.maxAmount || '0.00')
  // const partialPaymentAllowed = billObject?.product?.partialPaymentAllow === 'Y'
  // const billNumber = billObject?.bill?.id || 0
  // const feeInfo = getBpAuthenticatorValue('Agent Fee Amount')
  // const beneficiaryID = billObject?.beneficiary?.id || 0
  // const nickName = billObject?.beneficiary?.nickName || 'Test_456'
  // const agentFeeAmount = extractMetaValue(billObject, 'Agent Fee Amount')
  // const feeInfoAmount = agentFeeAmount

  const customerName = `${RootStore.BillPaymentAgentOnboard.firstName} ${RootStore.BillPaymentAgentOnboard.lastName}`

  const [isEditingAmount, setIsEditingAmount] = useState(false)
  const [amountError, setAmountError] = useState('')

  const { callGetProductListBC, getBrowsePlanListActionBC, getCircleListActionBC, createOrderAPIActionBC } = useStores(
    (root) => ({
      callGetProductListBC: root.BillPaymentAgentOnboard.callGetProductListBC,
      getBrowsePlanListActionBC: root.BillPaymentAgentOnboard.getBrowsePlanListActionBC,
      getCircleListActionBC: root.BillPaymentAgentOnboard.getCircleListActionBC,
      createOrderAPIActionBC: root.BillPaymentAgentOnboard.createOrderAPIActionBC,
    }),
  )
  const [runCreateOrder, createOrderTracker] = useLazyApiData(createOrderAPIActionBC)

  const fetchPlans = useCallback(
    async (opId: number, cId: number) => {
      console.error('Missing billerMasterId or circleMasterId. Skipping plan fetch.')
      console.log('Missing billerMasterId or circleMasterId. Skipping plan fetch, Operator or Circle details missing')
      if (!opId || !cId) {
        setPlanError('Operator or Circle details missing.')
        return
      }
      setLoadingPlans(true)
      setPlansByTab({})
      setPlanError(null)

      try {
        console.log(`Calling getBrowsePlanListActionBC with billerMasterId: ${opId}, circleMasterId: ${cId}`)
        const plansResponse = await getBrowsePlanListActionBC({
          billerMasterId: opId,
          circleMasterId: cId,
          mobileNumber: mobileNumber,
          categoryId: categoryId,
        })
        console.log('Plan API Response:', plansResponse)
        if (
          plansResponse &&
          Array.isArray(plansResponse) &&
          plansResponse.length > 0 &&
          plansResponse[0].browsePlanResponse &&
          plansResponse[0].browsePlanResponse.browsePlanResponseMap
        ) {
          const planResponseWrapper = plansResponse[0].browsePlanResponse
          const planMap = planResponseWrapper.browsePlanResponseMap as PlansByTab

          setPlansByTab(planMap)
          const tabKeys = Object.keys(planMap)

          if (tabKeys.length > 0) {
            setActiveTab(tabKeys[0])
            console.log('Tabs created:', tabKeys)
          }
        } else {
          setPlansByTab({})
          setPlanError('No plans found for this operator/circle.')
        }
      } catch (error) {
        console.error('Error fetching plans:', error)
        setPlanError(getErrorMessage(error))
      } finally {
        setLoadingPlans(false)
      }
    },
    [getBrowsePlanListActionBC, mobileNumber, categoryId, setLoadingPlans, setPlansByTab, setPlanError, setActiveTab],
  )

  const fetchCircles = useCallback(
    async (opId: number) => {
      if (!opId) return
      setCircleList([])
      setCircleListError(null)
      setLoadingCircles(true)
      setShowMappingErrorDialog(false)

      try {
        console.log(`Calling getCircleListActionBC for operator ID: ${opId}`)
        const circleResponse = await getCircleListActionBC({
          domain: {
            id: 'PayMyBill',
            name: 'PayMyBill',
            transactionType: 'BUY',
            description: 'This is for the buy case',
          },
          initiatingEntity: {
            entityId: '3147',
            channelId: null,
            returnUrl: null,
            callbackUrl: null,
          },
          product: {
            id: opId.toString(),
          },
        })
        console.log('getCircleListActionBC circleAPIResponse', circleResponse)

        if (Array.isArray(circleResponse) && circleResponse.length > 0) {
          const circles: Circle[] = circleResponse.map((item: any) => ({
            circleMasterId: item.circleDetails.id,
            circleName: item.circleDetails.name,
          }))

          setCircleList(circles)
          // setCircleID()
          console.log('circleResponse processed circles list:', circles)
        } else {
          setCircleListError('No circles found for this operator.')
          setSelectedCircle(null)
          setPlansByTab({})
          console.log('No circles found, setting error state.')
        }
      } catch (error) {
        console.error('Error fetching circles:', error)

        if (error?.code === 'ERR0035') {
          setCircleListError(
            'This operator is currently not mapped to any service circles. Please try a different operator.',
          )
        } else {
          setCircleListError(error?.message || 'An unknown error occurred while fetching circle details.')
        }
        setCircleList([])
        setSelectedCircle(null)
        setPlansByTab({})
      } finally {
        setLoadingCircles(false)
      }
    },
    [
      getCircleListActionBC,
      selectedCircle,
      setSelectedCircle,
      setCircleList,
      setCircleListError,
      setLoadingCircles,
      setPlansByTab,
    ],
  )

  const fetchOperators = async () => {
    setOperatorList([])
    setOperatorError(null)
    setLoadingOperators(true)
    try {
      console.log('Calling callGetProductListBC for category ID:', CATEGORY_ID_MOBILE_PREPAID)
      const response = await callGetProductListBC(CATEGORY_ID_MOBILE_PREPAID)

      if (response && Array.isArray(response)) {
        const operators: Operator[] = response
          .filter((item: any) => item?.product?.id)
          .map((item: any) => ({
            id: item.product.id,
            name: item.product.displayName || item.product.name,
            logoName: item.product.logoName,
          }))

        setOperatorList(operators)
        if (operators.length > 0) {
          if (!selectedOperator || !operators.find((op) => op.id === selectedOperator.id)) {
            const defaultOperator = operators[0]
            setSelectedOperator(defaultOperator)
          }
        }
      } else {
        setOperatorError('No operators found.')
      }
    } catch (error) {
      console.error('Error fetching operators:', error)
      setOperatorError(getErrorMessage(error))
    } finally {
      setLoadingOperators(false)
    }
  }

  const initialLoadAndLrnMapping = async () => {
    const response = await callGetProductListBC(CATEGORY_ID_MOBILE_PREPAID)
    setproductId(response[0].product.id)
    // setCircleID(circleId)
    console.log('callGetProductListBC callGetProductListBC callGetProductListBC', response)
    console.log('response?.product?.type callGetProductListBC', response[0].product.type)
    console.log('response?.product?.id callGetProductListBC', response[0].product.id)
    if (response[0].product.type == 'RECHARGE') {
      const initialOperatorDetails = lrnMappingData.length > 0 ? lrnMappingData[0] : null
      if (initialOperatorDetails) {
        if (operatorId === initialOperatorDetails.product.id && circleId === initialOperatorDetails.circleDetails.id) {
          return
        }
        const initialOp: Operator = {
          id: initialOperatorDetails.product.id,
          name: initialOperatorDetails.product.name,
        }
        const initialCircle: Circle = {
          circleMasterId: initialOperatorDetails.circleDetails.id,
          circleName: initialOperatorDetails.circleDetails.name,
        }
        setSelectedOperator(initialOp)
        setSelectedCircle(initialCircle)
      } else {
        fetchOperators()
      }
    }
  }

  useEffect(() => {
    if (Object.keys(tabMeasurements).length > 0) {
      scrollToCenter()
    }
  }, [activeTab, tabMeasurements])

  useEffect(() => {
    initialLoadAndLrnMapping()
  }, [])

  useEffect(() => {
    const operatorId = selectedOperator?.id
    const circleId = selectedCircle?.circleMasterId

    if (loadingOperators || loadingCircles || loadingPlans) {
      return
    }

    if (operatorId && circleId) {
      console.log('EFFECT: Triggering Plans fetch.')
      fetchPlans(operatorId, circleId)
    }
  }, [selectedOperator, selectedCircle, fetchPlans])

  const handleOperatorSelect = (operator: Operator) => {
    setSelectedOperator(operator)
    setSelectedCircle(null)
    setPlansByTab({})
    fetchCircles(operator.id)
    setShowCircleList(true)
    setShowOperatorList(false)
  }

  const handleCircleSelect = (circle: Circle) => {
    setSelectedCircle(circle)
    setShowCircleList(false)
    const opId = selectedOperator?.id
    const cId = circle.circleMasterId

    if (opId && cId) {
      fetchPlans(opId, cId)
    }
  }

  const handleEditClick = () => {
    setShowOperatorList(true)
    if (operatorList.length === 0 || operatorError) {
      fetchOperators()
    }
  }

  const handleInactivityDialogPress = () => {
    setShowInactivityDialog(false)
  }

  const handleSelectNewOperator = () => {
    setShowMappingErrorDialog(false)
    setShowOperatorList(true)
  }

  const handleShowMappingErrorDialog = () => {
    setShowMappingErrorDialog(true)
  }
  const handleCreateOrderAPI = async (plan: RechargePlan | null) => {
    if (!plan) return
    setIsLoading(true)
    if (!merchantUserId) {
      // RootStore.message.setMessage('Customer ID (jfsUserId) is missing. Cannot proceed.', 'ERROR')
      setIsLoading(false)
      return
    }

    try {
      const isWeb = Platform.OS === 'web'

      const createOrderPayload = {
        domain: {
          id: 'PayMyBill',
          name: 'PayMyBill',
          orderType: 'BUY',
          description: 'Mobile Prepaid Recharge',
        },
        initiatingEntity: {
          entityId: RootStore.agent.session.CHANNEL_ID || '',
          channelId: RootStore.agent.session.CHANNEL_ID || '',
          returnUrl: returnUrl,
          callbackUrl: '',
        },
        headerConfig: {
          ver: '1',
          ts: new Date().toISOString(),
          traceId: generateRandomString(16) || 'vEhxoXeKHn3d3RMm',
          origInstId: 'abdc',
        },
        product: {
          id: productId || selectedOperator?.id?.toString() || '', // id: plansResponse[0].product?.id,
          attribute: {
            authenticatorList: [mobileNumber, String(circleId)],
          },
        },
        bill: {
          number: 'NA',
          amountDetails: {
            netAmount: plan.amount,
          },
        },
        payment: {
          amountDetails: {
            netAmount: plan.amount,
          },
        },
        customerDetails: {
          jfsUserId: jfsUserId || null,
          mobile: {
            number: customerMobile || '8369186718',
            countryCode: '91',
          },
        },
        beneficiary: {
          id: beneficiaryID || '',
          nickName: nickName || '',
        },
        partner: {
          channelCode: 'JIOFIN',
        },
        agent: {
          merchantId: RootStore.agent.agentInfo.agentUserLoginId || 'MIDQCX00294',
          // "merchantUserId": "1593568304453221171",
          merchantUserId: merchantUserId || '1688674961054023685',
          feeInfo: {
            amount: agentFeeAmount || '0.00',
            isIncludePayAmt: 'Y',
          },
          customerInfo: {
            name: customerFullName || 'Customer Name',
            narration: 'cusotmerInfo',
            mobile: customerMobile || '8369186718', // Use local variable
            email: 'customer@mail.com',
          },
          paymentCollectionMode: 'CASH',
        },
        // metaData: {
        //   platform: Platform.OS,
        //   callbackMode: isWeb ? 'postMessage' : 'redirect',
        // },
      }

      console.log('Final Order Payload for createOrderPayload:', createOrderPayload)
      const response = await runCreateOrder(createOrderPayload)
      console.log('Avinash we are callling API createOrderAPI createOrderAPIActionBC response', response)
      console.log('Initiating order for:', selectedPlanDetails)

      // console.log('Order Created. Redirecting to:', response.responseObj.metaData.redirectionUrl)

      // navigation.navigate(Screens.PaymentProcessingScreen, {
      //   redirectionUrl: response.responseObj.metaData.redirectionUrl,
      //   orderId: response.responseObj.order.id,
      //   returnUrl: returnUrl,
      // })
      // console.log('Avinash we successfully navigated to PaymentProcessingScreen from Bill Details SCreen')
    } catch (error) {
      console.error('Create Order failed:', error)
      RootStore.message.handleError(error)
      RootStore.message.setMessage(error.message, 'ERROR')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (createOrderTracker.state === 'fulfilled' && createOrderTracker.data) {
      // Cast to any to prevent the "Property does not exist on type void" error
      const response = createOrderTracker.data as any
      const orderId = response?.order?.id

      console.log('RECHARGE: createOrderAPIActionBCHandler Order Success Response:', response)

      // 1. Extract dynamic data from the responseObj structure
      // Adjust these paths based on your actual API response structure
      const redirectionUrl = response?.metaData?.redirectionUrl || 'https://sit-jpbpg.test.jiobank.in:8443'
      const intentID = response?.order?.payment?.paymentProcessorId

      const appIdToken = response?.metaData?.appIdToken
      const appAccessToken = response?.metaData?.appAccessToken
      const channelId = RootStore.agent.session.CHANNEL_ID || '3155'
      const idempotentKey = response?.order?.idempotentKey || `JIO_PAY_${Date.now()}`

      console.log(
        'RECHARGE: API createOrderAPIActionBCHandler Response responseObj: responseObj: redirectionURL orderId',
        response,
        redirectionUrl,
        orderId,
      )

      if (orderId) {
        setOrderId(orderId)
        console.log('redirectionUrl redirectionUrl ', redirectionUrl)
        console.log('intentId intentId intentId intentId', intentID)
        console.log('appIdToken', appIdToken)
        console.log('appAccessToken appAccessToken idempotentKey', appAccessToken, idempotentKey)
        console.log('RECHARGE: Redirecting to dynamic URL: , responseObj orderId', redirectionUrl, response, orderId)

        console.log('RECHARGE: Navigating to PaymentProcessingScreen with dynamic URL:', redirectionUrl)
        console.log('redirectionUrl:', redirectionUrl)
        console.log('responseObj responseData:', response)
        console.log('returnUrl:', returnUrl)

        navigation.navigate(Screens.PaymentProcessingScreen, {
          redirectionUrl: redirectionUrl,
          // redirectionUrl: 'https://sit-jpbpg.test.jiobank.in:8443/',
          // redirectionUrl: 'https://netbanking.jiopaymentsbank.com/',
          orderId: orderId,
          pgPayload: {
            returnUrl: returnUrl,
            intentId: response?.order?.payment?.paymentProcessorId || '', // or actual path
            appIdToken: response?.metaData?.appIdToken || '',
            appAccessToken: response?.metaData?.appAccessToken || '',
            channelId: RootStore.agent.session.CHANNEL_ID || '3155',
            idempotentKey: response?.order?.idempotentKey || `JIO_PAY_${Date.now()}`,
          },
          isRecovery: false,
        })
      }

      // if (!responseObj) {
      //     console.log('createOrderAPIActionBC Failed Error')
      //     console.error('createOrderAPIActionBC Failed Error')
      //     return
      //   }
    } else if (createOrderTracker.state === 'rejected') {
      const error = createOrderTracker.data
      console.error('RECHARGE: Order creation failed.', error)
      // const { message } = getNetworkResponseError(error)
      // RootStore.message.setMessage(message || 'Failed to initiate payment', 'ERROR')
      //       console.error('RECHARGE: Redirection URL missing in API response')
      // RootStore.message.setMessage('Payment gateway could not be initialized.', 'ERROR')
    }
  }, [createOrderTracker.state, createOrderTracker.data, setOrderId, navigation, returnUrl])

  // const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/payment_processing_screen'
  // const redirectionURL = 'https://sit-atsweb.test.jiobank.in/payment_processing_screen'

  const handleCardPress = (planWrapper: PlanWrapper) => {
    const plan = planWrapper.rechargePlan
    setSelectedPlanDetails(plan)
    setEditableAmount(plan.amount.toString())
    setShowInactivityDialog(true)
  }

  const scrollToCenter = () => {
    const measurement = tabMeasurements[activeTab]
    const containerWidth = containerWidthRef.current

    if (measurement && tabsRef.current && containerWidth > 0) {
      const offset = measurement.x - containerWidth / 2 + measurement.width / 2
      tabsRef.current.scrollTo({ x: offset, y: 0, animated: true })
    }
  }
  if (planError) {
    const onRetry = () => setShowAllTabsDialog(true)
    return <ErrorState message={planError} onRetry={onRetry} />
  }
  if (tabKeys.length === 0 && !loadingPlans && operatorId && circleId) {
    return <NoPlansState />
  }

  const tabData = tabKeys.map((name) => ({
    title: name,
    // iconId: 'SMARTPHONE' // Optional: if you want icons in your tabs
  }))

  return (
    <Container showFooter={false} overflow="auto" paddingTop={0} paddingBottom={0} paddingHorizontal={0}>
      <>
        <Box>
          <Box flexDirection={'row'} alignItems={'center'} paddingHorizontal={16} paddingVertical={10}>
            <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
              Browse Prepaid Plans 📲 for {operatorName || 'Unknown Operator'} Operator in
              {circleName || ' Unknown Circle'} Circle
            </TextNew>
            <Box justifyContent={'center'} onPress={handleEditClick} height={20} marginLeft={5}>
              <Icon id={'EDIT'} color="AVAILABLE_GREEN" size={26} />
            </Box>
          </Box>
        </Box>
        {/* {tabKeys.length > 0 && (
          <Box
            flexDirection="row"
            alignItems="center"
            backgroundColor={'WHITE'}
            paddingHorizontal={10}
            height={50}
            onLayout={(e) => (containerWidthRef.current = e.nativeEvent.layout.width)}>
            <ScrollView
              ref={tabsRef}
              horizontal={true}
              showsHorizontalScrollIndicator={false}
              style={{ flex: 1 }}
              contentContainerStyle={{ flexDirection: 'row', alignItems: 'center' }}>
              {tabKeys.map((tabName) => (
                <Box
                  key={tabName}
                  marginRight={6}
                  flexShrink={0}
                  onLayout={(e) => {
                    const { x, width } = e.nativeEvent.layout
                    setTabMeasurements((prev) => ({
                      ...prev,
                      [tabName]: { x, width },
                    }))
                  }}>
                  <Tab
                    title={tabName}
                    state={activeTab === tabName ? 'selected' : 'normal'}
                    type={'jpb'}
                    onSelected={() => setActiveTab(tabName)}
                  />
                </Box>
              ))}

              
            </ScrollView>
            <Box justifyContent={'center'} onPress={() => setShowAllTabsDialog(true)} height={50}>
              <Icon id="MENU" size={24} color="BLACK" />
            </Box>
          </Box>
        )} */}

        {tabKeys.length > 0 && (
          <Box
            flexDirection="row"
            backgroundColor={'#DF9F39' as any}
            alignItems="center"
            onLayout={(e) => (containerWidthRef.current = e.nativeEvent.layout.width)}>
            <ScrollView
              ref={tabsRef}
              horizontal
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={{ paddingHorizontal: 8 }}>
              {tabKeys.map((tabName) => (
                <CustomTab
                  key={tabName}
                  title={tabName}
                  state={activeTab === tabName ? 'selected' : 'normal'}
                  onSelected={() => setActiveTab(tabName)}
                  onLayout={(e) => {
                    const { x, width } = e.nativeEvent.layout
                    setTabMeasurements((prev) => ({ ...prev, [tabName]: { x, width } }))
                  }}
                />
              ))}
            </ScrollView>
            <TouchableOpacity style={styles.menuButton} onPress={() => setShowAllTabsDialog(true)}>
              <Icon id="MENU" size={20} color="WHITE" />
            </TouchableOpacity>
          </Box>
        )}

        {loadingPlans && selectedOperator && selectedCircle ? (
          <PlanSkeletonList />
        ) : (
          <Box paddingHorizontal={16} paddingVertical={10}>
            {activePlans.length > 0 && ( // Only show plan count if plans are available
              <Box marginBottom={15}>
                <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
                  Showing {activePlans.length} plans in the **{activeTab}** category.
                </TextNew>
              </Box>
            )}

            {activePlans.map((planWrapper: PlanWrapper) => {
              const plan = planWrapper.rechargePlan
              return (
                <BillerCard
                  key={`${activeTab}-${plan.id}`}
                  displayName={`₹${plan.amount} - ${plan.packageName}`}
                  minAmount={plan.amount}
                  maxAmount={plan.amount}
                  isBbps={'N'}
                  onPress={() => handleCardPress(planWrapper)}
                  handleCreateOrderAPI={handleCreateOrderAPI}
                  selectedPlanDetails={plan}>
                  <Box
                    flexDirection="row"
                    justifyContent="space-between"
                    alignItems="center"
                    marginTop={5}
                    width="100%">
                    {/* ... Existing Plan Metric Boxes (Validity, Data, Talktime) ... */}
                    <Box alignItems="center" flex={1}>
                      <Icon id="CALENDAR" size={18} color="BRAND_COLOR_GRAY_1" />
                      <SpacerNew size={4} />
                      <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
                        Validity
                      </TextNew>
                      <TextNew fontSize={12} color="BLACK" fontWeight="bold">
                        {plan.validity}
                      </TextNew>
                    </Box>

                    <Box alignItems="center" flex={1}>
                      <Icon id="DATA_CARD" size={18} color="BRAND_COLOR_GRAY_1" />
                      <SpacerNew size={4} />
                      <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
                        Data
                      </TextNew>
                      <TextNew fontSize={12} color="BLACK" fontWeight="bold">
                        {plan.data}
                      </TextNew>
                    </Box>

                    {plan.talktime && plan.talktime !== 'NA' && (
                      <Box alignItems="center" flex={1}>
                        <Icon id="MOBILE" size={18} color="BRAND_COLOR_GRAY_1" />
                        <SpacerNew size={4} />
                        <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
                          Talktime
                        </TextNew>
                        <TextNew fontSize={12} color="BLACK" fontWeight="bold">
                          {plan.talktime}
                        </TextNew>
                      </Box>
                    )}
                  </Box>
                </BillerCard>
              )
            })}
          </Box>
        )}
        <Box backgroundColor="GRADIENT_ORANGE_FADE">
          <VerticleDrawerDialog
            show={showInactivityDialog}
            type="POSITIVE"
            onPress={handleInactivityDialogPress}
            message={'View Plan Details and Plan Description'}>
            {selectedPlanDetails ? (
              <>
                <Box alignContent="flex-start" marginBottom={10}>
                  <TextNew fontSize={22} lineHeight={28} color="BLACK" fontWeight="bold" textAlign="left">
                    {`₹${selectedPlanDetails.amount}` || 'Plan Details'}
                  </TextNew>
                </Box>
                {/* <Box
                  flexDirection="row"
                  alignItems="center"
                  borderBottomWidth={1}
                  borderColor="PRIMARY_GREY"
                  paddingVertical={5}>
                  <TextNew fontSize={22} fontWeight="bold">
                    ₹
                  </TextNew>

                  <TextInput
                    style={{
                      fontSize: 22,
                      fontWeight: 'bold',
                      flex: 1,
                      marginLeft: 5,
                      color: 'black', // Ensure text is visible
                    }}
                    value={editableAmount}
                    onChangeText={(text) => setEditableAmount(text)} // Use onChangeText for RN
                    keyboardType="numeric" // This will now work correctly
                    placeholder="0.00"
                  />
                </Box> */}

                <Box
                  width={'100%'}
                  marginTop={16}
                  paddingHorizontal={0}
                  paddingVertical={15}
                  borderTopWidth={1}
                  marginBottom={16}
                  borderStyle={'dashed'}
                  borderColor={'PRIMARY_GREY'}>
                  <Box
                    backgroundColor="BG_PRIMARY"
                    paddingBottom={15}
                    paddingTop={15}
                    paddingHorizontal={15}
                    borderStyle={'dashed'}
                    borderTopWidth={1}
                    paddingRight={15}
                    borderColor={'PRIMARY_GREY'}>
                    <RowItem
                      heading="Plan Description"
                      detail={selectedPlanDetails.description}
                      headingTextColor="BRAND_COLOR_GRAY_1"
                      detailTextColor="BLACK"
                    />
                  </Box>

                  <SpacerNew size={15} />

                  <Box
                    backgroundColor="BG_PRIMARY"
                    paddingBottom={15}
                    paddingTop={15}
                    paddingHorizontal={15}
                    borderStyle={'dashed'}
                    paddingRight={15}
                    borderTopWidth={1}
                    borderColor={'PRIMARY_GREY'}>
                    <RowItem
                      heading="Data / Benefits"
                      detail={selectedPlanDetails.data}
                      headingTextColor="BRAND_COLOR_GRAY_1"
                      detailTextColor="BLACK"
                    />
                  </Box>
                  <SpacerNew size={15} />
                  <Box width="100%" borderTopWidth={1} borderColor={'PRIMARY_GREY'} borderStyle={'dashed'} />
                </Box>
                <Spacer size={24} />
              </>
            ) : (
              <Box flex={1} justifyContent="center" alignItems="center">
                <LoaderNew type="large" color="BRAND_PRIMARY_ACTION" />
                <SpacerNew size={15} />
                <TextNew>Loading plan details...</TextNew>
              </Box>
            )}
            <Box width={'100%'}>
              <AepsButton
                // onPress={() => handleCreateOrderAPI(selectedPlanDetails)}
                // onPress={() => {
                //   // Create a temporary plan object with the new amount
                //   const updatedPlan = { ...selectedPlanDetails, amount: editableAmount }
                //   handleCreateOrderAPI(updatedPlan)
                //   setShowInactivityDialog(false)
                // }}
                onPress={() => {
                  if (selectedPlanDetails) {
                    // Pass the edited amount to your API handler
                    handleCreateOrderAPI({
                      ...selectedPlanDetails,
                      amount: editableAmount,
                    })
                    setShowInactivityDialog(false)
                  }
                }}
                title={isLoading ? 'Processing...' : `Proceed to Recharge for ₹${selectedPlanDetails?.amount}`}
                disabled={isLoading} // Disable while the API is calling
                borderRadius={15}
              />
            </Box>
          </VerticleDrawerDialog>

          {/* All Tabs Dialog */}
          <VerticleDrawerDialog
            show={showAllTabsDialog}
            type="POSITIVE"
            onPress={() => setShowAllTabsDialog(false)}
            message={''}>
            <TextNew fontSize={18} fontWeight="bold">
              All Plan Categories
            </TextNew>
            {tabKeys.map((tabName, index) => (
              <Box
                key={tabName}
                width={'100%'}
                paddingVertical={12}
                paddingHorizontal={16}
                borderBottomWidth={index < tabKeys.length - 1 ? 1 : 0}
                borderColor={'PRIMARY_GREY'}
                onPress={() => {
                  setActiveTab(tabName)
                  setShowAllTabsDialog(false)
                }}
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center">
                <TextNew
                  fontSize={16}
                  fontWeight={activeTab === tabName ? 'bold' : 'normal'}
                  color={activeTab === tabName ? 'BRAND_PRIMARY_ACTION' : 'BLACK'}>
                  {tabName}
                </TextNew>
                {activeTab === tabName && <Icon id="TICKMARK" size={18} color="BRAND_PRIMARY_ACTION" />}
              </Box>
            ))}
            <SpacerNew size={24} />
          </VerticleDrawerDialog>
          <VerticleDrawerDialog
            show={showOperatorList}
            type="POSITIVE"
            onPress={() => setShowOperatorList(false)}
            message={''}>
            <TextNew fontSize={18} fontWeight="bold">
              Select Mobile Operator
            </TextNew>
            {operatorList.map((operator, index) => (
              <Box
                key={operator.id}
                width={'100%'}
                paddingVertical={12}
                paddingHorizontal={16}
                // Correct the index check to use operatorList.length
                borderBottomWidth={index < operatorList.length - 1 ? 1 : 0}
                borderColor={'PRIMARY_GREY'}
                onPress={() => handleOperatorSelect(operator)}
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center">
                <TextNew
                  fontSize={16}
                  fontWeight={selectedOperator?.id === operator.id ? 'bold' : 'normal'}
                  color={selectedOperator?.id === operator.id ? 'BRAND_PRIMARY_ACTION' : 'BLACK'}>
                  {operator.name}
                </TextNew>

                {selectedOperator?.id === operator.id && <Icon id="TICKMARK" size={18} color="BRAND_PRIMARY_ACTION" />}
              </Box>
            ))}
            <SpacerNew size={24} />
          </VerticleDrawerDialog>
          <VerticleDrawerDialog
            show={showCircleList}
            type="POSITIVE"
            onPress={() => setShowCircleList(false)}
            message={''}>
            <TextNew fontSize={18} fontWeight="bold">
              Select Circle for {selectedOperator?.name || 'Operator'}
            </TextNew>

            {circleListError ? (
              <Box width="100%" alignItems="center" paddingHorizontal={16}>
                <Box flexDirection={'row'}>
                  <Icon id="STATUS_FAILED" size={10} color="RED" />
                  {/* <SpacerNew size={16} />                */}
                  <TextNew color="RED" fontSize={16} fontWeight="bold" textAlign="center">
                      Error: Circle Mapping Not Found                
                  </TextNew>
                </Box>
                <SpacerNew size={8} />               
                <TextNew color="RED" textAlign="center">
                    {circleListError}               
                </TextNew>
                <AepsButton
                  onPress={() => {
                    setShowCircleList(false)
                    setShowOperatorList(true)
                  }}
                  title="Choose Another Operator"
                  disabled={false}
                  borderRadius={15}
                />
                             
              </Box>
            ) : (
              <ScrollView style={{ maxHeight: 300, width: '100%' }}>
                {circleList.map((circle, index) => (
                  <Box
                    key={circle.circleMasterId}
                    width={'100%'}
                    paddingVertical={12}
                    paddingHorizontal={16}
                    borderBottomWidth={index < circleList.length - 1 ? 1 : 0}
                    borderColor={'PRIMARY_GREY'}
                    onPress={() => handleCircleSelect(circle)}
                    flexDirection="row"
                    justifyContent="space-between"
                    alignItems="center">
                    <TextNew
                      fontSize={16}
                      fontWeight={selectedCircle?.circleMasterId === circle.circleMasterId ? 'bold' : 'normal'}
                      color={
                        selectedCircle?.circleMasterId === circle.circleMasterId ? 'BRAND_PRIMARY_ACTION' : 'BLACK'
                      }>
                      {circle.circleName}
                    </TextNew>
                    {selectedCircle?.circleMasterId === circle.circleMasterId && (
                      <Icon id="TICKMARK" size={18} color="BRAND_PRIMARY_ACTION" />
                    )}
                  </Box>
                ))}
              </ScrollView>
            )}
            <SpacerNew size={24} />
          </VerticleDrawerDialog>
        </Box>
      </>
    </Container>
  )
}

const styles = StyleSheet.create({
  tabItem: {
    paddingHorizontal: 16,
    paddingVertical: 14,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 100,
  },
  activeBorder: {
    position: 'absolute',
    bottom: 0,
    left: 10,
    right: 10,
    height: 3,
    backgroundColor: '#FFFFFF', // White Active Border
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },
  menuButton: {
    paddingHorizontal: 15,
    height: '100%',
    justifyContent: 'center',
    backgroundColor: '#DF9F39', // Slightly darker brown
  },
})

// {tabKeys.length > 0 && (
//                 <Box
//                   backgroundColor={"#863838" as any}// Matches tab background for a seamless look
//                   flexDirection="row"
//                   alignItems="center">
//                   <Box flex={1}>
//                     <Tabbar
//                       type="jpb"
//                       titles={tabKeys.map((name) => ({ title: name }))}
//                       default={tabKeys.indexOf(activeTab)}
//                       onSelected={(index) => setActiveTab(tabKeys[index])}
//                       contentContainerStyle={{
//                         paddingHorizontal: 10,
//                         backgroundColor: '#A52A2A', // Ensures brown background spans full width
//                       }}
//                     />
//                   </Box>

//                   {/* Menu Icon Box */}
//                   <Box
//                     justifyContent="center"
//                     paddingHorizontal={10}
//                     onPress={() => setShowAllTabsDialog(true)}
//                     height={50}>
//                     <Icon id="MENU" size={24} color="WHITE" />
//                   </Box>
//                 </Box>
//               )}
// <Box alignContent="flex-start" marginBottom={10}>
//   <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
//     Confirm or Edit Amount
//   </TextNew>
//   <Box flexDirection="row" alignItems="center" borderBottomWidth={1} borderColor="PRIMARY_GREY" paddingVertical={5}>
//     <TextNew fontSize={22} fontWeight="bold">
//       ₹
//     </TextNew>
//     {/* Replace this with your project's Input component if available */}
//     <input
//       style={{
//         fontSize: 22,
//         fontWeight: 'bold',
//         borderWidth: 0,
//         outline: 'none',
//         flex: 1,
//         marginLeft: 5,
//       }}
//       value={editableAmount}
//       onChange={(e) => setEditableAmount(e.target.value)}
//       keyboardType="numeric"
//     />
//   </Box>
// </Box>

//  {tabKeys.length > 0 && (
//           <Box backgroundColor="WHITE" height={60} paddingVertical={5}>
//             <Tabbar
//               type="default"
//               titles={tabData}
//               default={tabKeys.indexOf(activeTab)} // Tells Tabbar which index is "selected"
//               onSelected={(index) => setActiveTab(tabKeys[index])} // Updates your state
//               contentContainerStyle={{ paddingHorizontal: 16, alignItems: 'center' }}
//             />

//             {/* Keep the Menu icon for the "Show All" functionality */}
//             <Box
//               position="absolute"
//               right={0}
//               top={0}
//               bottom={0}
//               justifyContent="center"
//               backgroundColor="WHITE"
//               paddingHorizontal={10}
//               onPress={() => setShowAllTabsDialog(true)}>
//               <Icon id="MENU" size={24} color="BLACK" />
//             </Box>
//           </Box>
//         )}

// const buildPaymentRedirectUrl = (response: any, environment: string) => {
//   console.log('response in buildPaymentRedirectUrl', response)
//   try {
//     const redirectionData = response?.data
//     console.log('redirectionData in buildPaymentRedirectUrl', response)
//     const transaction = response?.transaction
//     const metadata = transaction?.metadata // NOTE: This BASE_URL assumes SIT environment and /2FA/loadInitials path.
//     const BASE_URL = 'https://sit-jpbpg.test.jiobank.in:8443/2FA'
//     // const BASE_URL = `${process.env.PAYMENT_GATEWAY_URL}:8443/2FA`
//     console.log('PAYMENT_GATEWAY_URL', BASE_URL)
//     const intentId = transaction.id
//     const idempotentKeyForRedirect = transaction.idempotentKey
//     const appIdToken = encodeURIComponent(RootStore.agent.session.appIdToken || '')
//     // const appIdToken = encodeURIComponent(metadata['x-appid-token'] || '')
//     // const appAccessToken = encodeURIComponent(metadata['x-app-access-token'] || '')
//     const appAccessToken = encodeURIComponent(RootStore.agent.session.appAccessToken || '')
//     const channelId = '3155'
//     // const RETURN_URL = response?.transaction?.initiatingEntity?.callbackUrl || 'http://localhost:9002/jfs/v1/plan'
//     // const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/mobile_recharge'
//     // const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/load_initials/Mobile_Bill_Payment?categoryName=Prepaid Mobile&categoryId=100001&displayName=Prepaid Mobile Payments&mobileNumber=9561569457&productList=&lrnMapping=[object Object]'
//     // const RETURN_URL = 'https://lend-uat.jiopayment.ezeefin.net.in/iaAPI/v1/redirectURL'
//     // const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/payment_processing_screen'

//     // const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/transaction_details_screen'
//     // const RETURN_URL = 'https://sit-apig.test.jiobank.in/Mobile_Bill_Payment'

//     // const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/payment_processing_screen' 404 (Not Found)
//     const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/payment_processing_screen'

//     const returnUrl = encodeURIComponent(RETURN_URL)
//     console.log(
//       'BASE_URL, returnUrl, channelId, appAccessToken, appIdToken, idempotentKeyForRedirect, intentId, metadata, transaction',
//       BASE_URL,
//       returnUrl,
//       channelId,
//       appAccessToken,
//       appIdToken,
//       idempotentKeyForRedirect,
//       intentId,
//       metadata,
//       transaction,
//     )
//     return `${BASE_URL}?intentId=${intentId}&channelId=${channelId}&idempotentKey=${idempotentKeyForRedirect}&appAccessToken=${appAccessToken}&appIdToken=${appIdToken}&returnUrl=${returnUrl}`
//   } catch (e) {
//     console.error('Failed to build redirect URL:', e)
//     return null
//   }
// }

// const handleRecharge = () => {
//   if (!selectedPlanDetails || !selectedOperator || !selectedCircle) {
//     console.error('Recharge failed: Missing plan, operator, or circle details.')
//     return
//   }

//   setShowInactivityDialog(false)
//   const planAmount = parseFloat(selectedPlanDetails.amount)
//   const uniqueKey = generateRandomString(12)
//   const referenceNumber = Date.now().toString().substring(0, 15)
//   const requestBody = {
//     transaction: {
//       idempotentKey: 'JIO_PAY_34akjs87678js4',
//       currency: 356,
//       invoice: 'JIO2FA_CREATE-INTENT-0013',
//       method: {
//         type: 319,
//       },
//       referenceNumber: 123455334355234,
//       mode: 1,
//       livemode: 'false',
//       captureMethod: 1,
//       application: 2103,
//       initiatingEntityTimestamp: '2025-07-31T15:54:07.011Z',
//       initiatingEntity: {
//         entityId: 8008,
//         callbackUrl: 'http://localhost:9002/jfs/v1/plan',
//       },
//       standingInstruction: {
//         uniqueMandateNumber: 'd2461b22-7fb5-4257-83f5-84b17601c083',
//       },
//     },
//     amount: {
//       grossAmount: 100,
//       netAmount: 100,
//     },
//     payer: {
//       type: 1,
//       name: 'Name',
//       email: 'user@xyz.com',
//       externalId: '12123123',
//       mobile: {
//         number: '9920393322',
//         countryCode: '91',
//       },
//     },
//     payee: {
//       merchantId: '100001000074697',
//       type: 2,
//       name: 'RRL',
//       email: 'test@xyz.com',
//     },
//   }

//   const requestBody = {
//     transaction: {
//       idempotentKey: `JIO_PAY_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`,
//       currency: 356,
//       invoice: `JIO2FA_CREATE-INTENT-${selectedOperator.id}-${selectedCircle.circleMasterId}`,
//       method: {
//         type: 319,
//       },
//       referenceNumber: Math.floor(Date.now() / 1000) + Math.floor(Math.random() * 10000000),
//       mode: 1,
//       livemode: 'false',
//       captureMethod: 1,
//       application: 2103,
//       initiatingEntityTimestamp: new Date().toISOString(),
//       initiatingEntity: {
//         entityId: 3155,
//         callbackUrl: 'https://sit-atsweb.test.jiobank.in/payment_processing_screen',
//         // callbackUrl: 'https://sit-atsweb.test.jiobank.in/payment_processing_screen',
//         // callbackUrl: 'https://sit-atsweb.test.jiobank.in/payment_processing_screen', 404 (Not Found)
//         // callbackUrl: 'https://sit-atsweb.test.jiobank.in/transaction_details_screen',
//         // callbackUrl: 'https://localhost.com/Mobile_Bill_Payment',
//         // callbackUrl: 'localhost://Mobile_Bill_Payment',
//         // callbackUrl: 'https://lend-uat.jiopayment.ezeefin.net.in/iaAPI/v1/redirectURL',
//         // callbackUrl: 'https://sit-atsweb.test.jiobank.in/load_initials',
//         // callbackUrl: 'http://localhost:9002/jfs/v1/plan',
//       },
//       // standingInstruction: {
//       //   uniqueMandateNumber: 'd2461b22-7fb5-4257-83f5-84b17601c083', // Use a real UMN or omit if not SI
//       // },
//     },
//     amount: {
//       grossAmount: planAmount,
//       netAmount: planAmount,
//     },
//     payer: {
//       type: 1,
//       name: 'Payer Name Here',
//       email: 'payer@example.com',
//       externalId: '12123123',
//       mobile: {
//         number: mobileNumber,
//         countryCode: '91',
//       },
//     },
//     payee: {
//       merchantId: '100001000074697',
//       type: 2,
//       name: 'RRL',
//       email: 'test@xyz.com',
//     },
//   }
//   console.log('RECHARGE: Calling createIntentAPI with payload:', requestBody)
//   lazycreateIntentAPIAction(requestBody)
// }
// useEffect(() => {
//   if (createIntentAPIActionHandler.state === 'fulfilled') {
//     const response = createIntentAPIActionHandler.data
//     console.log(response, 'RECHARGE: API Intent created successfully! Response:', response)
//     const orderId: string | number = response?.transaction?.id || 'UNKNOWN_ORDER_ID'
//     const paymentUrl = buildPaymentRedirectUrl(response, 'SIT')
//     if (!paymentUrl) {
//       console.log('Payment Error', 'Failed to generate a valid Payment Gateway URL. Please try again.')
//       console.error('RECHARGE: Failed to generate payment URL.')
//       return
//     }

//     // const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/payment_processing_screen'   //404 (Not Found)
//     // const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/transaction_details_screen'
//     // const RETURN_URL = 'https://lend-uat.jiopayment.ezeefin.net.in/iaAPI/v1/redirectURL'
//     // const RETURN_URL ='https://sit-atsweb.test.jiobank.in/Mobile_Bill_Payment
//     // const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/payment_processing_screen'
//     const RETURN_URL = 'https://sit-atsweb.test.jiobank.in/payment_processing_screen'
//     console.log('RECHARGE: Navigating to PaymentProcessingScreen with dynamic URL:', paymentUrl)
//     console.log('redirectionUrl:', paymentUrl)
//     console.log('postData:', paymentUrl)
//     console.log('returnUrl:', RETURN_URL)
//     navigation.navigate(Screens.PaymentProcessingScreen, {
//       redirectionUrl: paymentUrl,
//       orderId: orderId.toString(),
//       returnUrl: RETURN_URL,
//     })
//     console.log('orderId', orderId)
//   } else if (createIntentAPIActionHandler.state === 'rejected') {
//     const error = createIntentAPIActionHandler.data
//     console.error('RECHARGE: Failed to create API Intent.', error)
//     const { message } = getNetworkResponseError(error)
//     console.log('Payment Initiation Failed', message)
//     RootStore.message.handleError(error)
//   }
// }, [createIntentAPIActionHandler.state, createIntentAPIActionHandler.data, navigation])

// <VerticleDrawerDialog
//             show={showAllTabsDialog}
//             type="POSITIVE"
//             onPress={() => setShowAllTabsDialog(false)}
//             message={''}>
//             <TextNew fontSize={18} fontWeight="bold">
//               All Plan Categories
//             </TextNew>
//             {tabKeys.map((tabName, index) => (
//               <Box
//                 key={tabName}
//                 width={'100%'}
//                 paddingVertical={12}
//                 paddingHorizontal={16}
//                 borderBottomWidth={index < tabKeys.length - 1 ? 1 : 0}
//                 borderColor={'PRIMARY_GREY'}
//                 onPress={() => {
//                   setActiveTab(tabName)
//                   setShowAllTabsDialog(false)
//                 }}
//                 flexDirection="row"
//                 justifyContent="space-between"
//                 alignItems="center">
//                 <TextNew
//                   fontSize={16}
//                   fontWeight={activeTab === tabName ? 'bold' : 'normal'}
//                   color={activeTab === tabName ? 'BRAND_PRIMARY_ACTION' : 'BLACK'}>
//                   {tabName}
//                 </TextNew>
//                 {activeTab === tabName && <Icon id="TICKMARK" size={18} color="BRAND_PRIMARY_ACTION" />}
//               </Box>
//             ))}
//             <SpacerNew size={24} />
//           </VerticleDrawerDialog>
//           <VerticleDrawerDialog
//             show={showOperatorList}
//             type="POSITIVE"
//             onPress={() => setShowOperatorList(false)}
//             message={''}>
//             <TextNew fontSize={18} fontWeight="bold">
//               Select Mobile Operator
//             </TextNew>
//             {operatorList.map((operator, index) => (
//               <Box
//                 key={operator.id}
//                 width={'100%'}
//                 paddingVertical={12}
//                 paddingHorizontal={16}
//                 // Correct the index check to use operatorList.length
//                 borderBottomWidth={index < operatorList.length - 1 ? 1 : 0}
//                 borderColor={'PRIMARY_GREY'}
//                 onPress={() => handleOperatorSelect(operator)}
//                 flexDirection="row"
//                 justifyContent="space-between"
//                 alignItems="center">
//                 <TextNew
//                   fontSize={16}
//                   fontWeight={selectedOperator?.id === operator.id ? 'bold' : 'normal'}
//                   color={selectedOperator?.id === operator.id ? 'BRAND_PRIMARY_ACTION' : 'BLACK'}>
//                   {operator.name}
//                 </TextNew>

//                 {selectedOperator?.id === operator.id && <Icon id="TICKMARK" size={18} color="BRAND_PRIMARY_ACTION" />}
//               </Box>
//             ))}
//             <SpacerNew size={24} />
//           </VerticleDrawerDialog>
//           <VerticleDrawerDialog
//             show={showCircleList}
//             type="POSITIVE"
//             onPress={() => setShowCircleList(false)}
//             message={''}>
//             <TextNew fontSize={18} fontWeight="bold">
//               Select Circle for {selectedOperator?.name || 'Operator'}
//             </TextNew>

//             {circleListError ? (
//               <Box width="100%" alignItems="center" paddingHorizontal={16}>
//                 <Box flexDirection={'row'}>
//                   <Icon id="STATUS_FAILED" size={10} color="RED" />
//                   {/* <SpacerNew size={16} />                */}
//                   <TextNew color="RED" fontSize={16} fontWeight="bold" textAlign="center">
//                       Error: Circle Mapping Not Found
//                   </TextNew>
//                 </Box>
//                 <SpacerNew size={8} />
//                 <TextNew color="RED" textAlign="center">
//                     {circleListError}
//                 </TextNew>
//                 <AepsButton
//                   onPress={() => {
//                     setShowCircleList(false)
//                     setShowOperatorList(true)
//                   }}
//                   title="Choose Another Operator"
//                   disabled={false}
//                   borderRadius={15}
//                 />
//
//               </Box>
//             ) : (
//               <ScrollView style={{ maxHeight: 300, width: '100%' }}>
//                 {circleList.map((circle, index) => (
//                   <Box
//                     key={circle.circleMasterId}
//                     width={'100%'}
//                     paddingVertical={12}
//                     paddingHorizontal={16}
//                     borderBottomWidth={index < circleList.length - 1 ? 1 : 0}
//                     borderColor={'PRIMARY_GREY'}
//                     onPress={() => handleCircleSelect(circle)}
//                     flexDirection="row"
//                     justifyContent="space-between"
//                     alignItems="center">
//                     <TextNew
//                       fontSize={16}
//                       fontWeight={selectedCircle?.circleMasterId === circle.circleMasterId ? 'bold' : 'normal'}
//                       color={
//                         selectedCircle?.circleMasterId === circle.circleMasterId ? 'BRAND_PRIMARY_ACTION' : 'BLACK'
//                       }>
//                       {circle.circleName}
//                     </TextNew>
//                     {selectedCircle?.circleMasterId === circle.circleMasterId && (
//                       <Icon id="TICKMARK" size={18} color="BRAND_PRIMARY_ACTION" />
//                     )}
//                   </Box>
//                 ))}
//               </ScrollView>
//             )}
//             <SpacerNew size={24} />
//           </VerticleDrawerDialog>

// <VerticleDrawerDialog
//             show={showMappingErrorDialog}
//             type="POSITIVE"
//             onPress={() => setShowMappingErrorDialog(false)}
//             message={''} // Message prop is unused since we use children
//           >
//             <Box alignItems={'center'} width={'100%'}>
//               <Icon id="STATUS_FAILED" size={48} color="RED" />
//               <SpacerNew size={16} />
//               <TextNew fontSize={20} lineHeight={28} color="BLACK" fontWeight="bold" textAlign="center">
//                 Operator Mapping Error
//               </TextNew>
//               <SpacerNew size={8} />
//               <TextNew fontSize={18} fontWeight="bold">
//                 {circleListError || 'The selected operator is not correctly mapped. Please choose another operator.'}
//               </TextNew>
//               <SpacerNew size={24} />

//               {/* Action Button: Calls handler to show the operator list */}
//               <AepsButton
//                 onPress={handleSelectNewOperator}
//                 title="Choose Another Operator"
//                 disabled={false}
//                 borderRadius={15}
//               />
//               <Spacer size={8} />
//             </Box>
//           </VerticleDrawerDialog>

// export const MobileBillPayment = () => {
//   return (
//     <Container showFooter={true} overflow="auto">
//       <>
//
//         <Box>
//
//           <Box>
//
//             <TextNew fontSize={18} color="BLACK">
//                             Browse Prepaid Plans 📲
//             </TextNew>
//
//             <TextNew fontSize={12} color="BRAND_COLOR_GRAY_1">
//               Plans for **{operatorName || 'Unknown Operator'}** in **
//               {circleName || 'Unknown Circle'}**
//             </TextNew>
//
//           </Box>
//
//         </Box>
//                {/* Dynamic Tabs Section */}
//         {tabKeys.length > 0 && (
//           <Box flexDirection="row" overflow="scroll" marginTop={20} marginBottom={10}>
//             {tabKeys.map((tabName) => (
//               <Tab
//                 key={tabName}
//                 title={tabName}
//                 state={activeTab === tabName ? 'selected' : 'normal'}
//                 onSelected={() => setActiveTab(tabName)}
//               />
//             ))}
//           </Box>
//         )}
//         {/* Plan List Section */}
//         <Box>
//           <Box marginBottom={10}>
//             <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
//               Showing {activePlans.length} plans in the **{activeTab}** category.
//             </TextNew>
//           </Box>

//         </Box>
//                 {/* Inactivity Dialog and other components (kept for context) */}
//                 <InactivityDialog visible={showInactivityDialog} onClose={() => setShowInactivityDialog(false)} />
//
//       </>
//
//     </Container>
//   )
// }

// const mockFetchTrendingBillers = () => {
//   /* This function is a placeholder for the actual API call.
//        In a real app, this would return the 'responseObject' array. */
// }

// const useLazyApiData = (apiFn) => {
//   const [data, setData] = useState(null)
//   const [loading, setLoading] = useState(false)
//   const [error, setError] = useState(null)

//   const callApi = async () => {
//     setLoading(true)
//     setError(null)
//     try {
//       // Simulate an API call with a delay
//       const mockData = await new Promise((resolve) =>
//         setTimeout(() => {
//           // Mock data based on the section
//           if (apiFn.name === 'fetchFavourites') {
//             resolve([
//               {
//                 id: '1',
//                 name: 'ICICI Bank FASTag',
//                 customerName: 'Prakash',
//                 vehicleNo: 'MH034589',
//                 lastLinked: 'O5 june 2025',
//               },
//               {
//                 id: '2',
//                 name: 'Airtel Postpaid',
//                 customerName: 'Rahul',
//                 mobileNo: '9876543210',
//                 lastLinked: '10 July 2025',
//               },
//             ])
//           } else if (apiFn.name === 'fetchRecentPayments') {
//             resolve([
//               {
//                 id: '3',
//                 name: 'BSES Rajdhani',
//                 customerName: 'Anil',
//                 accountNo: '12345678',
//                 lastLinked: '22 May 2025',
//               },
//               { id: '4', name: 'JioFiber', customerName: 'Priya', accountNo: '87654321', lastLinked: '01 June 2025' },
//             ])
//           } else {
//             resolve([])
//           }
//         }, 1000),
//       )
//       setData(mockData)
//     } catch (err) {
//       setError(err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   return [data, callApi, loading, error]
// }

// const mockFetchFavourites = () => {
//   console.log('Fetching mock favorites...')
//   return new Promise((resolve) =>
//     setTimeout(() => {
//       resolve([
//         {
//           id: '1',
//           name: 'ICICI Bank FASTag',
//           customerName: 'Prakash',
//           vehicleNo: 'MH034589',
//           lastLinked: 'O5 june 2025',
//         },
//         { id: '2', name: 'Airtel Postpaid', customerName: 'Rahul', mobileNo: '9876543210', lastLinked: '10 July 2025' },
//       ])
//     }, 1000),
//   )
// }
// const mockFetchRecentPayments = () => {
//   console.log('Fetching mock recent payments...')
//   return new Promise((resolve) =>
//     setTimeout(() => {
//       resolve([
//         { id: '3', name: 'BSES Rajdhani', customerName: 'Anil', accountNo: '12345678', lastLinked: '22 May 2025' },
//       ])
//     }, 1000),
//   )
// }
